export const IconCar = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M5.333 18.625v.594q0 .741-.486 1.261t-1.18.52q-.695 0-1.18-.52A1.78 1.78 0 0 1 2 19.22v-8.49q0-.21.028-.416.027-.209.083-.386l2.083-6.324q.223-.712.806-1.158A2.1 2.1 0 0 1 6.306 2h11.388q.723 0 1.306.445.583.446.806 1.158l2.083 6.324q.056.177.083.386.028.207.028.415v8.49q0 .743-.486 1.262-.486.52-1.18.52-.695 0-1.181-.52a1.78 1.78 0 0 1-.486-1.261v-.594zM5.111 7.938H18.89l-1.167-3.563H6.278zM7 15.063q.694 0 1.18-.52a1.78 1.78 0 0 0 .487-1.262 1.78 1.78 0 0 0-.486-1.261A1.56 1.56 0 0 0 7 11.5q-.694 0-1.18.52a1.78 1.78 0 0 0-.487 1.261q0 .743.486 1.262.487.52 1.181.52m10 0q.695 0 1.18-.52a1.78 1.78 0 0 0 .487-1.262 1.78 1.78 0 0 0-.486-1.261A1.56 1.56 0 0 0 17 11.5q-.695 0-1.18.52a1.78 1.78 0 0 0-.487 1.261q0 .743.486 1.262.486.52 1.181.52" />
    </svg>
  );
};
